<template>
  <IconEdit class="transition duration-200 cursor-pointer text-icon hover:text-icon-hover overflow-visible"
            @click.native="$emit('edit')"/>
</template>

<script>
import IconEdit from "@/components/icons/IconEdit";

export default {
  name: "Actions",
  components: {IconEdit}
}
</script>